<template>
  <SlideUpTransition>
    <button
      v-if="isVisible"
      class="to-top-btn--container"
      @click="scrollToTop"
    >
      <div class="to-top-btn cta--icon button-bordered">
        
      </div>
    </button>
  </SlideUpTransition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { SlideUpTransition } from '#components';

const isVisible = ref(false);

const handleScroll = () => {
  if (window.scrollY > 100) {
    isVisible.value = true;
  } else {
    isVisible.value = false;
  }
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
/* Behalten Sie nur die Basis-Styles für den Container bei */
.to-top-btn--container {
  position: fixed;
  z-index: 48;
  color: #ffffff;
  cursor: pointer;
}

/* Der Rest der Styles ist unverändert */
.to-top-btn {
  /* background-color: #3498db; */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); */

  &:hover {
    box-shadow: var(--shadow-toggler);
  }
}

.spacing-alternative {
  font-weight: bold;
}
</style>